<template>
  <div v-if="customer" class="py-6">
    <div class="flex justify-between items-center space-x-8 mb-8 border-b pb-4">
      <div>
        <h4 class="text-lg mr-4 leading-none font-semibold">
          {{ $t('components.customer.profile.creditCards.title') }}
        </h4>
        <p class="text-sm opacity-60 mt-2">
          {{ $t('components.customer.profile.creditCards.info') }}
        </p>
      </div>
      <div class="flex items-center space-x-2 flex-shrink-0">
        <o-button v-if="!customer.isArchived" variant="primary" flat @click="handleAddCreditCard">
          {{ $t('components.customer.profile.creditCards.add') }}
        </o-button>
      </div>
    </div>

    <template v-if="creditCards">
      <p v-if="loading || creditCards.length === 0" class="mb-8 opacity-60 text-sm">
        {{ loading ? $t('general.loadingEllipses') : $t('components.customer.profile.creditCards.noStoredCards') }}
      </p>
      <div v-else class="flex flex-wrap mb-3 mt-4">
        <credit-card
          v-for="creditCard in creditCards"
          :key="creditCard.idCreditCard"
          :customer="customer"
          :creditCard="creditCard"
          class="mr-4 mb-4"
        />
      </div>
    </template>

    <add-credit-card-dialog
      ref="addCreditCardDialog"
      @success="fetchCreditCards"
    />
  </div>
</template>

<script setup lang="ts">
import CreditCard from './creditCard.vue'
import AddCreditCardDialog from '@/components/customer/actions/CreditCardAdd.vue'

interface Props {
  customer: Record<string, any>
}

const props = defineProps<Props>()

const { $bus, $api } = useNuxtApp()

const addCreditCardDialog = ref<any>()
const creditCards = ref<any[] | null>(null)
const loading = ref(false)

const fetchCreditCards = async () => {
  loading.value = true

  try {
    const result = await $api.customer.creditCards(String(props.customer.idCustomer))
    creditCards.value = result.items
  } catch (e) {
    console.log(e)
  }

  loading.value = false
}

const handleAddCreditCard = () => {
  addCreditCardDialog.value.open(props.customer)
}

// created
fetchCreditCards()

const uid = getCurrentInstance()?.uid
$bus.on.all('CustomerCreditCard', uid, () => {
  fetchCreditCards()
})

onBeforeUnmount(() => {
  $bus.off.all(uid)
})
</script>
